import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { setUnauthorizedHandler } from '@/api/http'

import AppShell from '@/layouts/AppShell.vue'
import LoginView from '@/views/LoginView.vue'
import ScrollsView from '@/views/ScrollsView.vue'
import ScrollUploadView from '@/views/ScrollUploadView.vue'
import TokensView from '@/views/TokensView.vue'
import ProfileView from '@/views/ProfileView.vue'
import CheckView from '@/views/CheckView.vue'
import CheckLogView from '@/views/CheckLogView.vue'
import UsersView from '@/views/UsersView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { public: true },
  },
  {
    path: '/',
    component: AppShell,
    children: [
      { path: '', redirect: { name: 'check' } },
      { path: 'check', name: 'check', component: CheckView, meta: { title: 'Проверка субъекта' } },
      { path: 'check-log', name: 'check.log', component: CheckLogView, meta: { title: 'Журнал проверок' } },
      { path: 'scrolls', name: 'scrolls', component: ScrollsView, meta: { title: 'Перечни' } },
      { path: 'scrolls/upload', name: 'scrolls.upload', component: ScrollUploadView, meta: { title: 'Загрузка перечня' } },
      { path: 'tokens', name: 'tokens', component: TokensView, meta: { title: 'API-токены' } },
      { path: 'users', name: 'users', component: UsersView, meta: { title: 'Пользователи', adminOnly: true } },
      { path: 'profile', name: 'profile', component: ProfileView, meta: { title: 'Профиль' } },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: { name: 'check' } },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  if (!auth.bootstrapped) {
    await auth.fetchMe()
  }

  if (!to.meta.public && !auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'check' }
  }

  if (to.meta.adminOnly && auth.user?.role !== 'admin') {
    return { name: 'check' }
  }

  return true
})

setUnauthorizedHandler(() => {
  const auth = useAuthStore()
  auth.clear()
  if (router.currentRoute.value.name !== 'login') {
    router.push({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    })
  }
})

export default router
